import { Editor } from '@tiptap/react';
import { useMemo } from 'react';

export const useHyperlinkPopoverAnchor = (
  editor: Editor,
  isHyperlinkPopoverOpen: boolean,
) => {
  return useMemo(() => {
    if (!isHyperlinkPopoverOpen) return { top: 0, left: 0 };

    const { selection } = editor.view.state;
    const start = editor.view.coordsAtPos(selection.from);
    const end = editor.view.coordsAtPos(selection.to);

    return {
      top: end.bottom + 4,
      left: (start.left + end.left) / 2,
    };
  }, [editor, isHyperlinkPopoverOpen]);
};
